module.exports = __webpack_public_path__ + "static/media/Resume.93df3b33.pdf";